/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index tabs to autogenerate all the components and extensions
 * Used by "prepareTabss"
 */

import Tabs from './tabs/Tabs'
export * from './tabs/Tabs'
export default Tabs
